import { call, put } from "redux-saga/effects"
import { requestStartRevPennyDrop, requestRevPennyDropStatus } from "./bankDetailsRequests"
import {
  requestRevPennyDropFailure,
  requestRevPennyDropSuccess,
  getRevPennyDropSuccess,
  getRevPennyDropFailure,
} from "./bankDetailsSlice"
import errorHandler from '../../utils/handler'

export function* handleRequestRevPennyDrop(): Generator<any, any, any> {
  try {
    const response = yield call(requestStartRevPennyDrop)
    const { data, status } = response
    yield put(requestRevPennyDropSuccess({ data, loading: false, status }))
  } catch (error) {
    yield put(requestRevPennyDropFailure({
      error: errorHandler(error).message,
      status: errorHandler(error).status,
      isError: true,
    }))
  }
}

export function* handleGetRevPennyDropStatus(): Generator<any, any, any> {
  try {
    const response = yield call(requestRevPennyDropStatus)
    const { data, status } = response
    yield put(getRevPennyDropSuccess({ data, loading: false, status }))
  } catch (error) {
    yield put(getRevPennyDropFailure({
      error: errorHandler(error).message,
      status: errorHandler(error).status,
      isError: true,
    }))
  }
}
